<div #scrollToLocation></div>
<div class="mx-5">
  <div class="row">
    <div class="col-sm-3">

      <div class="row">
        <div class="col-md-12">
          <select class="w-100 input q-main-select q-light-main-focus" (change)="getChapters($event.target.value)">
            <option value="0">{{'Selectadigitallearningcycle_EL'|trad}}</option>
            <option *ngFor="let cyc of listCycleEL" value="{{cyc.Ident}}">{{cyc.Name}}</option>
          </select>
        </div>
      </div>
      <br />
      <div class="row" *ngIf="listChapters && listChapters.length > 0">
        <div class="col-md-12">
          <select class="w-100 input q-main-select q-light-main-focus" (change)="getLessons($event.target.value)">
            <option value="0">{{'Selectachapter_EL'|trad}}</option>
            <option *ngFor="let chap of listChapters" value="{{chap.Ident}}">{{chap.Title}}</option>
          </select>
        </div>
      </div>
      <div class="row" *ngIf="idCycleSelected && idCycleSelected !== '0' && (!listChapters || listChapters.length === 0)">
        <div class="col-md-12 text-center">
          <strong>{{'Nochapterinthiscycle_EL'|trad}}</strong>
        </div>
      </div>
      <div class="questFilter" *ngIf="listQuestionnaire.Lessons && listQuestionnaire.Lessons.length > 0">
        <div id="questDate" class="row mx-0 pt-3 px-2">
          <strong class="col-12 p-0 q-c-white">{{'Logindates_EL'|trad}} : </strong>
          <a class="col-1 p-0">{{'Du' | trad }}</a>
          <q-date class="col-12 col-lg-11 p-0 mb-1" [(ngValue)]="datePickerDebutInit" [min]="'1970-01-01'" (isValid)="dateDebutValid = $event" required></q-date>
          <a class="col-1 p-0">{{'Au' | trad }}</a>
          <q-date class="col-12 col-lg-11 p-0" [(ngValue)]="datePickerFinInit" [min]="'1970-01-01'" (isValid)="dateFinValid = $event" required></q-date>
        </div>
        <div class="questFilter">
          <div class="row">
            <div class="col-md-12">
              <button class="row m-0 questRefresh" (click)="refresh()">
                {{ 'Actualiser' | trad}}  <i class="fas fa-sync-alt ml-1 pt-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>


      <div *ngFor="let lesson of listQuestionnaire.Lessons, let i = index" style="margin-top:-1px;">
        <button class="accordionQuest p-0" (click)="accordion($event.target,i)" id="btn{{i}}">
          <div class="row m-0">
            <div class="col-1 activeQuest"><i class="fas fa-angle-right iconaccordion" *ngIf="lesson.DetailQuestionnaires && lesson.DetailQuestionnaires.length > 0"></i></div>
            <div class="col-xl-11 col-lg-10 col-sm-9 col-10 my-2 ellipsis"> <b title="{{lesson.Title}}">{{lesson.Title}}</b></div> 
          </div>
        </button>

        <div class="panel list-group" id="panel{{i}}">
          <div>
            <p class="mt-2 mb-1 ml-2 q-c-white">
              <i class="fas fa-graduation-cap" *ngIf="!lesson.Type || lesson.Type === 'EL'" title="{{'Classicelmodule_EL'|trad}}"></i>
              <i class="fas fa-headset" *ngIf="lesson.Type === 'BLINTERDIS' || lesson.Type === 'BLINTRADIS'" title="{{'Distancemodule_EL'|trad}}"></i>
              <i class="fas fa-map-marker-alt" *ngIf="lesson.Type === 'BLINTERPRE' || lesson.Type === 'BLINTRAPRE'" title="{{'Facetofacemodule_EL'|trad}}"></i>
              : {{lesson.Description}}
            </p>
            <p class="my-1 ml-2 q-c-white"><i class="fas fa-calendar-alt pr-1"></i> <strong>{{'Creationdate_EL'|trad}}</strong> : {{lesson.CreationDate}}</p>
            <p class="my-1 ml-2 q-c-white" *ngIf="!lesson.DetailQuestionnaires || lesson.DetailQuestionnaires.length < 1"><strong>{{'Noquestionnaire_EL'|trad}}</strong></p>
          </div>
          <a class=" py-1 panelQuest pt-1" *ngFor="let questionnaire of lesson.DetailQuestionnaires" (click)="GetLearnerResult(lesson.Ident, questionnaire.type, questionnaire.model, lesson.Title, questionnaire.titre, 0, true )">
            <i class="fas fa-chevron-right pr-1"></i>
            <i class="fas fa-pencil-alt" *ngIf="questionnaire.type === 'EXO'"></i>
            <i class="fas fa-question-circle" *ngIf="questionnaire.type !== 'EXO'"></i>
            {{questionnaire.titre}}
          </a>

        </div>
      </div>
    </div>
 
    <div *ngIf="listQuestionnaire && listQuestionnaire.LearnerList?.length;else NoQuestionnaireSelected" class="col-sm-9 list-group">
      <!--TAB MENU-->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link active q-hover" href="#questionnaireTab" data-toggle="tab">{{'result'| trad}}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link q-hover" href="#stat" data-toggle="tab">{{'statistic' | trad }}</a>
        </li>
      </ul>
      <!--PANE LISTE QUESTIONNAIRE-->
      <div class="tab-content">
        <div class="tab-pane active" id="questionnaireTab">
          <div class="container mx-0 border">
            <div class="row p-3 headerQuest">
              <b>{{lessonTitle}} - {{questionnaireName}}</b>  <button class="hidden-btn col-sm-1 q-c-main" title="{{'Downloadallthequestionnaire_EL' | trad }}" (click)="downloadAll()" *ngIf="ShowAllLearner"><i class="fas fa-download"></i></button>
            </div>
            <div class="row">
              <img src="./assets/images/loader.gif" class="q-imgloading" />
              <!--<div class="loader"></div>-->
            </div>

            <div class="row border-bottom" *ngIf="ShowAllLearner">
              <div class="col-sm-11 my-auto">
                <b>{{'sort' | trad }}</b>
                <input type="radio" name="Sort" id="nameSort" class="radio_hidden" value="name" [(ngModel)]="learnerSorting" />
                <label for="nameSort"><u>{{'name' | trad }}</u>,</label>
                <input type="radio" name="Sort" id="markSort" class="radio_hidden" value="mark" [(ngModel)]="learnerSorting" />
                <label for="markSort"><u>{{'mark' | trad }}</u></label>
              </div>
              <button class="col-sm-1 close q-c-danger q-xxbigger" data-toggle="modal" *ngIf="isAdminQuestionnaire" data-target="#ModaleRaZAll" title="{{'MsgRaZAllQuest' | trad }}">&times;</button>
            </div>
            <div class="questionnaire row" *ngFor="let learner of (listQuestionnaire.LearnerList | learnerSort:learnerSorting)">

              <button type="button" class="hidden-btn col-sm-1" data-toggle="modal" data-target="#ModaleQuestionnaire" title="{{'Seethequestionnaire_EL' | trad }}" (click)="GoToAnswer(listQuestionnaire.IdLessonSelected,listQuestionnaire.ModelQuestionnaire,learner.ident, listQuestionnaire.ModelNameQuestionnaire)">
                <i class="fa fa-eye"></i>



              </button>
              <div class="col-sm-7 my-auto">{{learner.name}} {{learner.firstname}}</div>
              <span class="badge badge-success col-sm-1 pt-2 pb-2  note" [ngClass]="learner.questValid ? 'q-success' : 'q-warning'" *ngIf="learner.questionnaireCompleted && learner.isChecked==='1'"> {{learner.note}}/{{learner.noteMax}}</span>
              <span class="badge badge-success col-sm-1 pt-2 pb-2  note q-danger" title="Correction nécessaire" *ngIf="learner.questionnaireCompleted && learner.isChecked==='0'"> <i class="fas fa-pencil-alt fa-lg"></i></span>
              <span class="badge badge-warning col-sm-1 pt-2 pb-2 note-none" *ngIf="!learner.questionnaireCompleted"> -/</span>

              <div class="col-sm-1 my-auto" *ngIf="learner.questionnaireCompleted">{{ReturnDateLearner(learner.date)}}</div>

              <button *ngIf="learner.questionnaireCompleted" class="hidden-btn col-sm-1 q-c-main" title="{{'Downloadthequestionnaire_EL' | trad }}" (click)="download(learner.ident)"><i class="fas fa-download"></i></button>
              <div class="col-sm-1" *ngIf="!learner.questionnaireCompleted"></div>

              <button class="col-sm-1 close q-c-danger" *ngIf="learner.questionnaireCompleted && isAdminQuestionnaire" data-toggle="modal" data-target="#ModaleRaZ" (click)="InitModalRaZ(learner)" title="{{'RazResult' | trad}}">&times;</button>
              <div class="col-sm-1" *ngIf="!learner.note && isAdminQuestionnaire"></div>
            </div>
            <div *ngIf="!ShowAllLearner" class="row justify-content-center">
              <button type="button" class="btn q-main m-3" (click)="ShowMoreLearner()"><i  [ngClass]="[isLoadingMore ? 'fa-pulse fa-spin fa-spinner' : 'fa-plus']" class="fas"></i><span> Afficher plus</span></button>
            </div>
          </div>
        </div>
        <!--PANE LISTE QUESTIONNAIRE END-->
        <!--PANE STAT-->
        <div class="tab-pane" id="stat">
          <div class="container mx-0 border">
            <div class="row headerQuest p-3">
              <b>{{lessonTitle}} - {{questionnaireName}}</b>
            </div>
            <div class="row">
              <img src="./assets/images/loader.gif" class="q-imgloading" />
              <!--<div class="loader"></div>-->
            </div>
            <!--GRAPH-->
            <div class="row py-2" *ngIf="statModel?.chart?.length > 0;else no_data_templ">

              <div class="card col-lg-6 px-0">
                <div class="card-header">
                  {{'noteQuesitonnaire' | trad }}
                </div>
                <div class="card-body" id="graphDiv" style="min-height: 250px;padding: 0px 1.25rem;" *ngIf="noteModel?.chart?.length">
                  <quest-chart [ChartLabels]="noteModel.chart[0].label" [ChartData]="noteModel.chart[0].data[0]" [noteMax]="noteModel.postModel.noteMax"></quest-chart>
                </div>
              </div>
              <div class="col-lg-6 px-0" *ngFor="let chart of statModel.chart, let colorId = index">
                <div class="card">
                  <div class="card-header">
                    {{chart.question}}
                  </div>
                  <div class="card-body">
                    <ng-container [ngSwitch]="chart.chartType">
                      <ng-template [ngSwitchCase]="'GAPFILL'">
                        <quest-pie [ChartLabels]="chart.label" [ChartData]="chart.barData" [IdChart]="colorId"></quest-pie>
                      </ng-template>
                      <ng-template [ngSwitchDefault]>
                        <div *ngFor="let data of chart.barData">
                          <quest-bar [Text]="data.Label" [Value]="data.Value" [MaxValue]="nbApprenant" [ChartType]="chart.chartType" [Color]="colorId"></quest-bar>
                        </div>
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #no_data_templ>
              <div class="noData q-c-light-main">
                <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
                {{'NoData'|trad}}
              </div>
            </ng-template>
            <!--END GRAPH-->
          </div>
        </div>
        <!--PANE STAT END-->
      </div>
    </div>
    <ng-template #NoQuestionnaireSelected>
      <div class="col-sm-9 list-group">
        <!--TAB MENU-->
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link active q-hover" href="#questionnaireTab" data-toggle="tab">
              {{'result'| trad }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link q-hover" href="#stat" data-toggle="tab">{{'statistic' | trad }}</a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="questionnaireTab">
            <div class="container mx-0 border">
              <div class="row headerQuest p-3">
              </div>
              <div class="row">
                <img src="./assets/images/loader.gif" class="q-imgloading" />
                <!--<div class="loader"></div>-->
              </div>
              <div class="noData q-c-light-main">
                <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
                {{'SelectQuest'|trad}}
              </div>
            </div>
          </div>
          <!--PANE LISTE QUESTIONNAIRE END-->
          <!--PANE STAT-->
          <div class="tab-pane " id="stat">
            <div class="container mx-0 border">
              <div class="row headerQuest p-3">
              </div>
              <div class="row">
                <img src="./assets/images/loader.gif" class="q-imgloading" />
              </div>
              <div class="noData q-c-light-main">
                <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
                {{'SelectQuest'|trad}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <!--<button class="btn btn-circle btn-lg btn-bottom color_button" (click)="goback()"> <i class="fa fa-arrow-left 2x"></i></button>-->
</div>
<!-- Modal -->
<div class="modal fade" id="ModaleQuestionnaire" tabindex="-1" role="dialog" aria-labelledby="ModaleQuestionnaire" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modalQuest m-3" role="document">
    <div class="modal-content">
      <button type="button" class="close closeModal" data-dismiss="modal" aria-label="Close" #closeBtn>
        <span aria-hidden="true">&times;</span>
      </button>
      <q-questionnaire *ngIf="answerModel.modeQuestionnaire =='trainer'" [inputAnswerModel]="answerModel" class="py-2"></q-questionnaire>
    </div>
  </div>
</div>
<!-- Modal RaZ resultat-->
<div class="modal fade" id="ModaleRaZ" tabindex="-1" role="dialog" aria-labelledby="ModaleRaZ" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeRaZBtn>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row px-4">
          {{'MsgRaZQuest'|trad}}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="q-btn" data-dismiss="modal">
          {{'no'| trad}}
        </button>
        <button type="button" class="q-btn q-main" (click)="RazInfoQuestionnaire(false)">{{'yes_EL'| trad}}</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal RaZ ALL resultats-->
<div class="modal fade" id="ModaleRaZAll" tabindex="-1" role="dialog" aria-labelledby="ModaleRaZAll" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeRaZAllBtn>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row px-4">
          {{'MsgRaZAllQuest'|trad}} ?
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="q-btn" data-dismiss="modal">
          {{'no'| trad}}
        </button>
        <button type="button" class="q-btn q-main" (click)="RazInfoQuestionnaire(true)">{{'yes_EL'| trad}}</button>
      </div>
    </div>
  </div>
</div>


